import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";

import DoSeeListPage from "../../../layout/DoSeeListPage";
import { _TYPES_ } from "../utils/types";
import { pushOneTipsAndAdvice } from "../../../lib/sysNavigation/SysNavigation";

type TipsRow = {
  tips_and_advice_id: number | string;
  title?: string;
  slug?: string;
  [key: string]: unknown;
};

const Overview: React.FC = () => (
  <DoSeeListPage<TipsRow>
    type={_TYPES_.TIPSANDADVICE}
    title="Tips & Advice"
    subtitle="Traveller tips featured on the public site."
    icon={<HiOutlineInformationCircle className="h-5 w-5" />}
    addRoute="/data/tips/advice/add"
    editRoute="/data/tips/advice/edit"
    pushOne={pushOneTipsAndAdvice}
    dataKey="tipsAndAdvice"
    countKey="tipsAndAdviceCount"
    idField="tips_and_advice_id"
  />
);

export default Overview;
